import React from 'react'
import { formatRouteForPush, Routes } from '@/core/router/routes'
import { ComunicadoEnvioHomeBoxCortex } from '@/modules/comunicado-utils/ui/comunicado-envio-home-box-cortex'
import { useHomeOnboarding } from '../hooks/use-home-onboarding'
import { Carousel } from '../components/carousel'
import { InfoCard } from '../components/info-card'
import { Footer } from '@/modules/home/components/footer'
import { BibliotecaVirtualLastCreatedBox } from '@/modules/biblioteca-virtual/components'

type ItensMenu = {
  title: string
  theme: string
  productName: string
  currentProduct: string
  linkHelpTec: string
  linkPortal: string
  linkAcademia: string
  brandImageUrl: string
  notifications: Array<{
    __typename: string
    id: string
    titulo: string
    texto: string
    produto: string
    link: string
    data: string
    recente: boolean
  }>
  notificationCount: number
  locales: Array<{
    id: string
    description: string
  }>
}

export interface HomeDesktopProps {
  itensMenu: ItensMenu
}

export const HomeDesktop = (props: HomeDesktopProps) => {
  useHomeOnboarding(props)

  return (
    <div className={'flex flex-col mb-deca'}>
      <div className={'flex my-deca gap-x-deca'}>
        <Carousel {...props} />
        <InfoCard />
      </div>
      <div className={'flex flex-col lg:flex-row gap-deca'}>
        <ComunicadoEnvioHomeBoxCortex
          pathRoute={formatRouteForPush(Routes.COMUNICADOS, [])}
        />
        <BibliotecaVirtualLastCreatedBox
          pathRoute={formatRouteForPush(Routes.BIBLIOTECA_VIRTUAL, [])}
        />
      </div>
      <Footer />
    </div>
  )
}
